import { apiGet } from '../../api'

export const get_venues = () => {
  return apiGet({
    endpoint: 'venue/all_venues'
  })
}
